import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RequireAdmin = () => {
  const session = localStorage.getItem('adminSession');

  if (!session) {
    return <Navigate to="/admin/login" replace />;
  }

  try {
    JSON.parse(session);
    return <Outlet />;
  } catch {
    localStorage.removeItem('adminSession');
    return <Navigate to="/admin/login" replace />;
  }
};

export default RequireAdmin;
